import React, { Component } from 'react'
import { Button, Form, Input, Upload, Icon, Select } from 'antd'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { message } from 'antd'
import config from '../../utils/config'
import InputMask from 'react-input-mask';
import { CompactPicker } from 'react-color';
import { get, create } from '../../services/restApi'
import PropTypes from 'prop-types'
var IconAwesome = require('react-fontawesome');
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;

class HotelNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            imageUrl: '',
            file: {},
            loading: false,
            hotel: {},
            color: '#000000'
        }

        message.config({top: 110, duration: 4});
    }

    componentDidMount () {
        if (this.props.params.hotelId) {
            this.props.dispatch({type: 'app/showLoading'})

            get('Hotel', this.props.params.hotelId).then((resp) => {

                if (resp.type) 
                    resp.type = {key: resp.type, label: resp.type};

                if (resp.color)
                    this.setState({color: resp.color});

                this.props.form.setFieldsValue(resp)
                this.setState({
                    imageUrl: config.externalUrl + 'uploads/hotels/' + resp.picture,
                    hotel: resp
                });
                this.props.dispatch({type: 'app/hideLoading'})
            })
        }
    }

    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 2MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }

    handleChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }

    checkPhone(rule, value, callback) {
        const form = this.props.form;
        if (form.getFieldValue('phone') && form.getFieldValue('phone').replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }

    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Validations
            if (!this.state.imageUrl) {
                message.error('Debe subir el logo del hotel');
                return;
            }

            // Model
            values.color = values.color.hex;
            values.phone = values.phone.replace(/[^\d.]/g, '');
            if (this.state.file.uid) 
                values.picture = this.state.file.uid + '.jpg';

            if (values.type)
                values.type = values.type.key;
            
            if (!this.props.params.hotelId) {
                // CREA

                this.props.dispatch({type: 'app/showButtonLoading'})
                
                create('Hotel', values).then(resp => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el hotel exitosamente');

                    this.props.form.resetFields();
                    this.props.form.setFieldsValue({phone: ''})
                    this.setState({imageUrl: ''})

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                _.extend(this.state.hotel, values);
                this.props.dispatch({type: 'hotel/update', payload: this.state.hotel})
                this.context.router.goBack();
            }
        })
    }

    render () {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/hotels"><i className="fa fa-arrow-circle-left"></i></Link>
                        Hotel
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos del Nuevo Hotel
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="ant-form-item-required">Logo</label>
                                        <Upload
                                            className="avatar-uploader"
                                            name="file"
                                            accept="image/*"
                                            showUploadList={true}
                                            action={config.externalUrl + "includes/upload.php"}
                                            beforeUpload={this.beforeUpload.bind(this)}
                                            onChange={this.handleChange.bind(this)}
                                            headers={{
                                                "X-Parse-Application-Id": config.appId
                                            }}
                                            data={{
                                                type: 'hotel',
                                                custom_name: this.state.file.uid + '.jpg'
                                            }}
                                        >
                                            {this.state.imageUrl ?
                                                <img src={this.state.imageUrl} alt="" className="avatar" /> :
                                                this.state.loading ? 
                                                    <IconAwesome name="refresh" spin className="spin-uploader" />
                                                    : <Icon type="plus" className="avatar-uploader-trigger" />
                                            }
                                        </Upload>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="col-md-4">
                                            <FormItem label="Nombre" hasFeedback>
                                                {this.props.form.getFieldDecorator('name', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el nombre del hotel'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Tipo" hasFeedback>
                                                {this.props.form.getFieldDecorator('type', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, elija una opción',
                                                    }]
                                                })(
                                                    <Select 
                                                        size='large'
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        >
                                                        <Option key="hotel" label="hotel">Hotel</Option>
                                                        <Option key="restaurante" label="restaurante">Restaurante</Option>
                                                        <Option key="tours" label="tours">Tours</Option>
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Destino" hasFeedback>
                                                {this.props.form.getFieldDecorator('city', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el destino del hotel'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Dueño" hasFeedback>
                                                {this.props.form.getFieldDecorator('chief', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el nombre del dueño'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Correo electrónico" hasFeedback>
                                                {this.props.form.getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email',
                                                        required: true,
                                                        message: 'Por favor, ingrese el correo electrónico del hotel'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Teléfono" hasFeedback>
                                                {this.props.form.getFieldDecorator('phone', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el teléfono del hotel'
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Tipo de contrato" hasFeedback>
                                                {this.props.form.getFieldDecorator('contract_type', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el tipo de contrato'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Color">
                                                {this.props.form.getFieldDecorator('color', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, elije el color de configuración'
                                                    }]
                                                })(<CompactPicker 
                                                        color={ this.state.color } 
                                                        onChange={ (color) => { console.log(color); this.setState({ color: color.hex }) } }
                                                    />)}
                                            </FormItem>
                                        </div>
                                    </div>
                                </div>

                                <div className="row text-center">
                                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </section>
            </div>
        )
    }
}

HotelNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({hotel, app}) => ({hotel, app}))(Form.create()(HotelNew))


// WEBPACK FOOTER //
// ./src/components/hotels/hotelNew.js